import { useMutation } from "react-query";
import axios from "axios";
import Config from "../Config";
import { toast } from "react-toastify";

export const useChargesCalculation = (token, selectedDuesTotal, totalDuesAmount, gstAmount, setCharges, setTotalPayment) => {
    const chargesTransaction = async (values) => {
        return await axios.post(`${Config.ApiUrl}/transaction/charges/get`, values, {
            headers: {
                authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
            },
        });
    };

    const { isLoading: chargesTransactionLoading, mutate: chargesTransactionMutate } =
        useMutation(chargesTransaction, {
            onError: () => { },
        });

    const fetchChargesForSelectedMethod = (selectedPaymentOption, amountToPay, availableMethods, onComplete) => {
        if (amountToPay <= 0) return;

        const payload = {
            mode: selectedPaymentOption,
            amount: amountToPay,
        };

        chargesTransactionMutate(payload, {
            onSuccess: (response) => {
                const newCharges = response?.data?.data?.charges || "0";
                setCharges(newCharges);

                const total = (
                    parseFloat(amountToPay) +
                    parseFloat(newCharges || 0) +
                    parseFloat(gstAmount)
                ).toFixed(2);

                setTotalPayment(total);
                if (onComplete) onComplete(newCharges);
            },
            onError: (error) => {
                toast.error(error?.response?.data?.msg || "Failed to fetch charges");
                const selected = availableMethods?.find((m) => m.type === selectedPaymentOption);
                const fallbackCharges = selected?.initialCharges || "0";
                setCharges(fallbackCharges);

                const total = (
                    parseFloat(amountToPay) +
                    parseFloat(fallbackCharges || 0) +
                    parseFloat(gstAmount)
                ).toFixed(2);
                setTotalPayment(total);
                if (onComplete) onComplete(fallbackCharges);
            },
        });
    };

    return {
        fetchChargesForSelectedMethod,
        chargesTransactionLoading,
        chargesTransactionMutate,
    };
};